module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/Prizes/footwear-2fc3f5616fac5300242062133095859a.svg";